// extracted by mini-css-extract-plugin
export var lg = "_24-4";
export var md = "_24-3";
export var sm = "_24-2";
export var xs = "_24-1";
export var xxs = "_24-0";